import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {DEBTOR} from '../../constants/MicroServiceConstants';
import {
  MARITAL_STATUS,
  STATE,
  PHONE_TYPE,
  GENDER,
  RP_PHONE_TYPE,
  PREL,
} from '../../constants/Lookup';

const initialData = {
  accountGuarantorStatus: null,
  accountGuarantorData: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'AccountLegalActions',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchAccountGuarantorData: (state, action) => {
      state.accountGuarantorData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.accountGuarantorData = {};
    },
  },
});

export default slice.reducer;

// Actions

const {fetchAccountGuarantorData, fetchDropDownData, fetchStart, fetchError, resetData} =
  slice.actions;

export const getAccountGuarantor = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [MARITAL_STATUS, STATE, PHONE_TYPE, GENDER, RP_PHONE_TYPE, PREL],
      }),
      httpGet(`${DEBTOR}/find/guarantor/${accountNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const guarantorData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(lookUpApiData?.lookUpApiData?.error));
        }
        if (guarantorData && guarantorData.status && guarantorData.status === 200) {
          dispatch(fetchAccountGuarantorData(guarantorData.response));
        } else {
          dispatch(fetchError(guarantorData.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetAccountGuarantor = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
